import { useState, useEffect } from "react";
import axios from "axios";
import useAuth from "./useAuth"

export function useSelectedBlog() {
    const [selectedBlog, setSelectedBlog] = useState({});
    const [apiResponse, setApiResponse] = useState(null);
    const [brandId, setBrandId] = useState(null);
    const { user, loading } = useAuth();

    useEffect(() => {
        if (!user?.localId || loading) return;
        let blog = JSON.parse(localStorage.getItem("blog") || "{}");

        if (!blog.id) {
            fetchDefaultBlog().then((res) => {
                if (res.success && res.data) {
                    setApiResponse(res.data);

                }
            });
        } else {
            setSelectedBlog(blog);
            setApiResponse(blog);

        }

        window.addEventListener("storage", syncSelectedBlog);
        return () => window.removeEventListener("storage", syncSelectedBlog);
    }, [user, loading]);

    const fetchDefaultBlog = async () => {
        try {
            const token = localStorage.getItem("CRM_token") || localStorage.getItem("googleToken");
            const res = await axios.get("/guest/blogs", {
                headers: { Authorization: `Bearer ${token}` },
            });

            if (res.data.length) {
                const ownerBlog = res.data.find((blog) => blog.role === "owner");
                if (ownerBlog?.id) {
                    setSelectedBlog(ownerBlog);
                    localStorage.setItem("blog", JSON.stringify(ownerBlog));
                    return { success: true, data: ownerBlog };
                }
            }
            return { success: false, data: null };
        } catch {
            return { success: false, data: null };
        }
    };
    const syncSelectedBlog = () => {
        let blog = JSON.parse(localStorage.getItem("blog") || "{}");
        setSelectedBlog(blog);
        setApiResponse(blog);

    };

    return { selectedBlog, apiResponse, brandId };
}
